/*
 * @Author: Teemo Ding
 * @Date: 2022-04-14 17:00:51
 * @LastEditTime: 2022-06-06 15:11:23
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Permissions/PermissionList/Users/index.tsx
 */
import { Button } from '@/src/components/Antd';
import EditableTable from '@/src/components/EditableTable/EditableTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import { useHistory } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { NEW } from 'src/tools/constant';
import { i18nGet } from 'src/tools/tools';
import { columns } from '../config';
import css from '../style.module.less';

const Users = ({ users, timeZone, disableView, disableAdd }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const history = useHistory();
  const handleAddUser = () => {
    history.push(`/settings/permissionsDetail/${NEW}`);
  };
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={getI18n('usersAndPermissions.list.users')}>
      <EditableTable
        disableAdd
        data={users}
        columns={columns(timeZone, disableView, { getI18n })}
        id='PaymentListTable'
        rowKey='uuid'
      />
      <Button
        onClick={handleAddUser}
        className={css.addUser}
        type='primary'
        disabled={disableAdd}>
        {getI18n('usersAndPermissions.list.addUser')}
      </Button>
    </SectionWrapper>
  );
};

export default Users;
